import {useCallback} from 'react';
// import {useMsal} from './Msal';
import {useMsalContext} from '@/components/MSAL/MsalContextProvider';

export const apiEndpoint : string = import.meta.env.VITE_APP_API_ENDPOINT;

export type ApiFetch = (url : string | URL, init ?: RequestInit) => Promise<Response>;

let accessTokenPromise : Promise<string> | null = null;

const useApiFetch = () : ApiFetch => {
    const msal = useMsalContext();

    return useCallback(async (url : string | URL, init ?: RequestInit) => {
        let accessToken : string;

        if (!accessTokenPromise) {
            accessTokenPromise = msal.getAccessToken();
            accessToken = await accessTokenPromise;
            accessTokenPromise = null;
        } else {
            accessToken = await accessTokenPromise;
        }

        if (!init) {
            init = {};
        }

        init.headers = init.headers instanceof Headers ? init.headers : new Headers(init.headers);
        init.headers.set('Authorization', `Bearer ${accessToken}`);
        init.headers.set('Content-Type', 'application/json');

        return fetch(url, init);
    }, [msal]);
};

export default useApiFetch;
